import Api from "../../../services/Api";
import { sanitizeEmailPathParam } from "../../../lib/utils/apiValidation";

const BASE_URL = "/service/iqevse-csms/users/v1";

function userPath(email) {
  return `${BASE_URL}/${sanitizeEmailPathParam(email)}`;
}

export const userApi = {
  createUser: async userData => {
    const response = await Api.post(`${BASE_URL}/create`, userData);
    return response;
  },

  getUserByEmail: async email => {
    const response = await Api.get(userPath(email));
    return response;
  },

  getAllUsers: async () => {
    const response = await Api.get(`${BASE_URL}/getAllUsers`);
    return response;
  },

  updateUser: async (email, userData) => {
    const response = await Api.put(userPath(email), userData);
    return response;
  },

  deleteUser: async email => {
    const response = await Api.delete(`${BASE_URL}/delete/${sanitizeEmailPathParam(email)}`);
    return response;
  },

  getUserPermissions: async email => {
    const response = await Api.get(`${userPath(email)}/permissions`);
    return response;
  },
};
